<template>
  <div v-if="tags.length > 0" class="smallTagGroup">
    <div v-for="(item, index) in tags" class="smallTag" :key="index"><span>{{item.name}} </span><a v-if="!readOnly" v-on:click="closeButton(item.id)">(X)</a></div>
  </div>
</template>

<script>

export default {
  name: 'SmallTagGroup',
  props: {
    tags: Array,
    readOnly: Boolean
  },
  methods: {
    closeButton(tagID){
      this.$emit('closeButton',tagID);
    }
  }
}
</script>

<style>
  .smallTagGroup {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 12px;
    margin-left: 25px;
    margin-top: 20px;
    flex-wrap: wrap;
  }
  .smallTag {
    background-color: #2E303A;
    padding: 5px 15px;
    border-radius: 50px;
    margin: 5px 10px;
  }
  .smallTag span {
    color: #ffffff80;
  }
  .smallTag a {
    color: #ffffff50;
    cursor: pointer;
  }
</style>
